export default __webpack_public_path__ + "static/media/AdobeStock_309009238.92aa0136.jpg";